import { IonContent, IonPage } from '@ionic/react';
import React, { PropsWithChildren } from 'react';

type Props = { className?: string } & PropsWithChildren;

export default function SettingsGridWrapper({
  children,
  className = '',
}: Props) {
  return (
    <IonPage>
      <IonContent>
        <div
          className={`${className} pr-4 w-full min-h-full grid grid-cols-1 sm:grid-cols-[35%_60%] md:grid-cols-4 gap-6 `}
        >
          {children}
        </div>
      </IonContent>
    </IonPage>
  );
}
